import { render, staticRenderFns } from "./YzRadio.vue?vue&type=template&id=0b1ae2e8&scoped=true&lang=pug&"
import script from "./YzRadio.vue?vue&type=script&lang=js&"
export * from "./YzRadio.vue?vue&type=script&lang=js&"
import style0 from "./YzRadio.vue?vue&type=style&index=0&id=0b1ae2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ae2e8",
  null
  
)

export default component.exports